/*
 * Copyright (c) 2021 OCLC, Inc. All Rights Reserved.
 *
 * OCLC proprietary information: the enclosed materials contain proprietary information of OCLC Online Computer
 * Library Center, Inc. and shall not be disclosed in whole or in any part to any third party or used by any person
 * for any purpose, without written consent of OCLC, Inc.  Duplication of any portion of these materials shall include
 * this notice.
 */
import React, { useState } from 'react'
import { IntlProvider } from 'react-intl'
import Arabic from '../lang/ar.json'
import Catalan from '../lang/ca.json'
import Deutsch from '../lang/de.json'
import English from '../lang/en.json'
import Spanish from '../lang/es.json'
import French from '../lang/fr.json'
import Italian from '../lang/it.json'
import Japanese from '../lang/ja.json'
import Korean from '../lang/ko.json'
import Netherlands from '../lang/nl.json'
import Portuguese from '../lang/pt.json'
import Thai from '../lang/th.json'
import Turkish from '../lang/tr.json'
import Vietnamese from '../lang/vi.json'
import SimpleChinese from '../lang/zh-cn.json'
import TraditionalChinese from '../lang/zh-tw.json'
import PropTypes from 'prop-types'

export const LanguageContext = React.createContext()

const local = navigator.language.includes('zh') ? navigator.language : navigator.language.split('-')[0]
//todo: as other languages are added, this may become more complex and can be done w/in a function/hook

let lang
switch (local) {
  case 'ar':
    lang = Arabic
    break
  case 'ca':
    lang = Catalan
    break
  case 'de':
    lang = Deutsch
    break
  case 'en':
    lang = English
    break
  case 'es':
    lang = Spanish
    break
  case 'fr':
    lang = French
    break
  case 'it':
    lang = Italian
    break
  case 'ja':
    lang = Japanese
    break
  case 'ko':
    lang = Korean
    break
  case 'nl':
    lang = Netherlands
    break
  case 'pt':
    lang = Portuguese
    break
  case 'th':
    lang = Thai
    break
  case 'tr':
    lang = Turkish
    break
  case 'vi':
    lang = Vietnamese
    break
  case 'zh-cn':
    lang = SimpleChinese
    break
  case 'zh-tw':
    lang = TraditionalChinese
    break
  default:
    lang = English
    break
}

const LanguageWrapper = (props) => {
  const [locale, setLocale] = useState(local)
  const [messages, setMessages] = useState(lang)

  function selectLanguage(e) {
    const newLocale = e.target.value
    setLocale(newLocale)
    switch (newLocale) {
      case 'ar':
        setMessages(Arabic)
        break
      case 'ca':
        setMessages(Catalan)
        break
      case 'de':
        setMessages(Deutsch)
        break
      case 'en':
        setMessages(English)
        break
      case 'es':
        setMessages(Spanish)
        break
      case 'fr':
        setMessages(French)
        break
      case 'it':
        setMessages(Italian)
        break
      case 'ja':
        setMessages(Japanese)
        break
      case 'ko':
        setMessages(Korean)
        break
      case 'nl':
        setMessages(Netherlands)
        break
      case 'pt':
        setMessages(Portuguese)
        break
      case 'th':
        setMessages(Thai)
        break
      case 'tr':
        setMessages(Turkish)
        break
      case 'vi':
        setMessages(Vietnamese)
        break
      case 'zh-cn':
        setMessages(SimpleChinese)
        break
      case 'zh-tw':
        setMessages(TraditionalChinese)
        break
      default:
        setMessages(English)
        break
    }
  }

  const myCustomErrorFunction = () => {
    //ignores missing translations console errors
  }

  return (
    <LanguageContext.Provider value={{ locale, selectLanguage }}>
      <IntlProvider messages={messages} locale={locale} onError={myCustomErrorFunction}>
        {props.children}
      </IntlProvider>
    </LanguageContext.Provider>
  )
}

LanguageWrapper.propTypes = {
  children: PropTypes.node.isRequired,
}
export default LanguageWrapper
